<div [formGroup]="parentGroup">
    <mat-form-field appearance="fill" [ngClass]="{'invisible':formElement.hidden === 'true'}" class="emails-chip-list" [formControlName]="formElement.formControl">
        <mat-label>
            {{ formElement.text }}
        </mat-label>

        <mat-chip-grid #chipList aria-label="Enter emails">
            <mat-chip-row *ngFor="let email of emailAddresses" (removed)="remove(email)">
                {{email}}
                <button matChipRemove [attr.aria-label]="'remove ' + email">
                    <mat-icon class="material-icons-outlined">cancel</mat-icon>
                </button>
            </mat-chip-row>
            <input [placeholder]="translate.instant('AddEmailAddress', {Default: 'Add Email Address'})"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="add($event)"/>
        </mat-chip-grid>
        <div *ngIf="showValidEmailError" class="error-message" appLocalizationPopupDirective localizationCode="PleaseEnterValidEmail">
            {{ 'PleaseEnterValidEmail' | translate: {Default: "Please enter a valid email address"} }}
        </div>
    </mat-form-field>
</div>